import {IHttpService} from "angular";
import {EquityCollateral, UnlodgedCollateral} from "../../../../types/PortfolioMarginResult";
import {LodgeCollateralRequest, PortfolioCollateral, UnlodgeCollateralRequest} from "../models/PortfolioCollateral";

export class CollateralService {

    public static id = "collateralService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    public async collateralForPortfolio(portfolioId: number): Promise<PortfolioCollateral> {
        const url = `/tradefloor/api/portfolio/${portfolioId}/collateral`;
        const response = await this.$http.get<PortfolioCollateral>(url);
        return response.data!;
    }

    public async lodge(portfolioId: number, request: LodgeCollateralRequest): Promise<void> {
        const url = `/tradefloor/api/portfolio/${portfolioId}/collateral/lodge`;
        await this.$http.post(url, request);
    }

    public async unlodge(portfolioId: number, request: UnlodgeCollateralRequest) {
        const url = `/tradefloor/api/portfolio/${portfolioId}/collateral/unlodge`;
        await this.$http.post(url, request);
    }
}
